module.exports = __webpack_public_path__ + "static/media/palliatieve-zorg-jonge-vrouw-in-kas-large.7d356201.jpg";